import React from 'react';
import { IDataGridRowStatus } from '@trackman/baseball-shared-components';
import ErrorContent from './ErrorContent';
import { PlayNumber, StickyInningSeparator, ValidationCellWrapper, WarmupPitchLabel } from './styles/ValidationCellStyles';

export interface IProps {
  isFirstPlayInInning: boolean;
  style: any;
  cellContent: IDataGridRowStatus;
  isHidden: boolean;
  onMouseDownHandler?: any;
  onMouseEnterHandler?: any;
  isSelected?: boolean;
  rowIndex: number;
  columnIndex: number;
  playSequenceNumber: number | undefined;
}
export const ValidationCell: React.FC<IProps> = (props: IProps) => {
  const {
    style,
    cellContent,
    isHidden,
    onMouseDownHandler,
    onMouseEnterHandler,
    isSelected,
    rowIndex,
    columnIndex,
    playSequenceNumber,
    isFirstPlayInInning,
  } = props;

  return (
    <ValidationCellWrapper
      hidden={isHidden}
      style={{ ...style, width: 173 }}
      onMouseDown={(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void =>
        onMouseDownHandler && onMouseDownHandler(rowIndex, columnIndex, false, event, true)
      }
      onMouseEnter={(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void =>
        onMouseEnterHandler && onMouseEnterHandler(rowIndex, columnIndex, event, true)
      }
      isSelected={isSelected}
      isError={cellContent.errors.length > 0}
    >
      {isFirstPlayInInning && <StickyInningSeparator />}
      {playSequenceNumber && (
        <>
          <PlayNumber isFirstPlayInInning={isFirstPlayInInning} isError={cellContent.errors.length > 0}>
            {`${playSequenceNumber}`}
          </PlayNumber>
          <ErrorContent isFirstPlayInInning={isFirstPlayInInning} errors={cellContent.errors} />
        </>
      )}
      {!playSequenceNumber && <WarmupPitchLabel>Warm-up</WarmupPitchLabel>}
    </ValidationCellWrapper>
  );
};
